<template>
  <v-select
    class="recipientSelect"
    v-model="address"
    ref="select"
    :options="options"
    label="text"
    :onChange="onChange"
    placeholder="Search Address Book"
  ></v-select>
</template>

<style lang="scss" scoped>
</style>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      addresses: [],
      address: null,
      attributes: {
        'ref': 'openIndicator',
        'role': 'presentation',
        'class': 'vs__open-indicator',
      }
    };
  },
  computed: {
    ...mapGetters(['recipients']),
    options() {
      if(!this.recipients) {
        return [];
      }

      let recipients = {...this.recipients};

      let options = _.map(recipients, address => {
        let label = `${address.first_name || ''} ${address.last_name || ''}`;

        if(address.company && label.trim()) {
          label = `${label} - ${address.company}`;
        }else if(address.company){
          label = address.company;
        }

        return {
          value: address.id,
          text: `${label}, ${address.address}, ${address.city}, ${address.province}`
        };
      });

      return options;
    }
  },
  created() {
    this.refreshRecipients();
  },
  methods: {
    ...mapActions(['refreshRecipients']),
    onChange(val) {
      if (val) {
        this.$emit('input', val.value);
        this.$emit('change', val.value);
      } else {
        this.onClearItems();
        this.$emit('clear');
      }
    },
    onClearItems() {
      this.address = null;
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Form/RecipientSelect.vue